<template>
  <div id="addProcess">
    <el-dialog
      v-if="addVisible"
      :title="title"
      :visible.sync="addVisible"
      width="960px"
      :before-close="handleClose"
    >
      <el-form ref="form" :rules="rules" class="addForm" :model="addForm" label-width="110px">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="审批名称：" prop="FApprovalName">
              <el-input v-model="addForm.FApprovalName" :disabled="title === '查看审批'" />
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="发起账号：" prop="FPromoterIDs">
              <el-input v-model="addForm.FPromoterNames" :disabled="!!editProcess" clearable @clear="clearSelect(5)">
                <i slot="suffix" class="el-icon-menu" @click="selectAccountNumber(true,true,5,true)" />
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="审批流：">
              <el-select v-model="FLevel" :disabled="title === '查看审批'" style="width:100%" placeholder="请选择">
                <el-option
                  value="1"
                  label="一级审批"
                />
                <el-option
                  value="2"
                  label="二级审批"
                />
                <el-option
                  value="3"
                  label="三级审批"
                />
                <el-option
                  value="4"
                  label="四级审批"
                />
                <el-option
                  value="5"
                  label="五级审批"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="process-body">
        <!-- <svg-icon v-if="i != 0" :icon-class="processArr[i].svgClass" /> -->
        <div v-if="title != '查看审批'">
          <div v-for="(t,i) in addForm.FLevel" :key="i" :style="processArr[i].style" class="process-box">
            <div class="process-title">
              {{ processArr[i].text }}
            </div>
            <div class="process-content">
              <el-input v-model="FApprovalList[i].FApprovalUserName" clearable placeholder="请选择审批账号" @clear="clearSelect(i)">
                <i slot="suffix" class="el-icon-arrow-right" @click="selectAccountNumber(true,false,i)" />
              </el-input>
            </div>
          </div>
        </div>
        <div v-else style="display:flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;">
          <div v-for="(t,i) in addForm.FLevel" :key="i" class="see-Process">
            <div :style="processArr[i].style" class="process-box">
              <div class="process-title">
                {{ processArr[i].text }}
              </div>
              <div class="process-content">
                <el-input v-model="FApprovalList[i].FApprovalUserName" placeholder="请选择审批账号">
                  <i slot="suffix" class="el-icon-arrow-right" />
                </el-input>
              </div>
            </div>
            <svg-icon v-if="i != editProcess.FDetailList.length - 1" :icon-class="processArr[i].svgClass" />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="close_btn" @click="handleClose">取 消</el-button>
        <el-button class="confirm_btn" type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <searchDia
      v-if="searchVisible"
      ref="search"
      :is-checkout-box="isCheckoutBox"
      :search-visible="searchVisible"
      @cfmSearch="cfmSearch"
      @closeSearch="selectAccountNumber(false)"
    />
  </div>
</template>

<script>
import service from '@/utils/request'
import searchDia from './accountNumber.vue'
export default {
  components: {
    searchDia
  },
  props: {
    addVisible: {
      type: [Boolean]
    },
    title: {
      type: [String],
      default: ''
    },
    editProcess: {
      type: [Object],
      default: () => {}
    }
  },
  data() {
    return {
      selectType: null,
      isCheckoutBox: false,
      searchVisible: false,
      FLevel: '1',
      addForm: {
        FBillId: 0,
        FApprovalName: '',
        FPromoterIDs: '',
        FPromoterNames: '',
        FLevel: 1
      },
      FApprovalList: [
        {
          FStepIndex: 1,
          FApprovalUserId: '',
          FApprovalUserName: ''
        },
        {
          FStepIndex: 2,
          FApprovalUserId: '',
          FApprovalUserName: ''
        },
        {
          FStepIndex: 3,
          FApprovalUserId: '',
          FApprovalUserName: ''
        },
        {
          FStepIndex: 4,
          FApprovalUserId: '',
          FApprovalUserName: ''
        },
        {
          FStepIndex: 5,
          FApprovalUserId: '',
          FApprovalUserName: ''
        }
      ],
      rules: {
        FApprovalName: [
          { required: true, message: '请输入审核名称', trigger: 'blur' }
        ],
        FPromoterIDs: [
          { required: true, message: '请选择发起账号', trigger: 'change' }
        ]
      },
      processArr: [
        {
          text: '一级审批',
          svgClass: 'first-line',
          style: 'background:#F66666;'
        },
        {
          text: '二级审批',
          svgClass: 'second-line',
          style: 'background:#F6A066;'
        },
        {
          text: '三级审批',
          svgClass: 'thired-line',
          style: 'background:#42DFBA;'
        },
        {
          text: '四级审批',
          svgClass: 'fourth-line',
          style: 'background:#6692F6;'
        },
        {
          text: '五级审批',
          svgClass: '',
          style: 'background:#A76DFF;'
        }
      ]
    }
  },
  watch: {
    FLevel(val) {
      this.addForm.FLevel = Number(val)
    },
    addVisible(val) {
      if (val && this.editProcess) {
        const e = JSON.parse(JSON.stringify(this.editProcess))
        const a = this.addForm
        a.FBillId = e.FBillId
        a.FApprovalName = e.FApprovalName
        a.FLevel = e.FLevel
        this.FLevel = e.FLevel.toString()
        a.FPromoterIDs = e.FPromoterID
        a.FPromoterNames = e.FUserName
        e.FDetailList.forEach((t, i) => {
          const f = this.FApprovalList[i]
          f.FApprovalUserId = t.FApprovalUserId
          f.FApprovalUserName = t.FApprovalUserName
        })
      }
    }
  },
  methods: {
    handleClose() {
      this.addForm = {
        FBillId: 0,
        FApprovalName: '',
        FPromoterIDs: '',
        FPromoterNames: '',
        FLevel: 1
      }
      this.FLevel = '1'
      this.$refs.form.clearValidate()
      this.FApprovalList.forEach(item => {
        item.FApprovalUserId = item.FApprovalUserName = ''
      })
      this.$emit('addSwitch', false)
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let v = true
          for (let i = 0; i < this.addForm.FLevel; i++) {
            if (v) {
              if (!this.FApprovalList[i].FApprovalUserId || !this.FApprovalList[i].FApprovalUserName) {
                this.$message.error(`请选择${i + 1}级审批的审批账号`)
                v = false
                return
              }
            }
          }
          if (v) {
            const loadingObj = this.$loading({
              lock: true,
              text: '提交中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0,0,0,0.5)',
              target: document.querySelector('.submit-test-dialog')
            })
            const data = new URLSearchParams()
            const jsonobj = JSON.parse(JSON.stringify(this.addForm))
            jsonobj.FApprovalList = []
            for (let i = 0; i < jsonobj.FLevel; i++) {
              const obj = JSON.parse(JSON.stringify(this.FApprovalList[i]))
              delete obj.FApprovalUserName
              jsonobj.FApprovalList.push(obj)
            }
            data.append('jsonobj', JSON.stringify(jsonobj))
            service({
              url: '/mall/mallmanage/billapprovalPolicy/saveBillapproval',
              method: 'post',
              data
            })
              .then(res => {
                if (res.result) {
                  this.$message.success(res.msg)
                  this.$emit('onSearch')
                  this.handleClose(true)
                } else {
                  this.$message.error(res.msg)
                }
                loadingObj.close()
              })
              .catch(() => {
                loadingObj.close()
              })
          }
        }
      })
    },
    clearSelect(n) {
      if (n === 5) {
        this.addForm.FPromoterNames = this.addForm.FPromoterIDs = ''
      } else {
        this.FApprovalList[n].FApprovalUserId = this.FApprovalList[n].FApprovalUserName = ''
      }
    },
    cfmSearch(val) {
      if (this.selectType === 5) {
        const ids = []
        const names = []
        val.forEach(t => {
          ids.push(t.FID)
          names.push(t.FUserName)
        })
        this.addForm.FPromoterNames = names.toString()
        this.addForm.FPromoterIDs = ids.toString()
      } else {
        const s = this.$refs.search.getValue()
        this.FApprovalList[this.selectType].FApprovalUserId = s.length ? s[0].FID : ''
        this.FApprovalList[this.selectType].FApprovalUserName = s.length ? s[0].FUserName : ''
      }
      this.searchVisible = false
    },
    selectAccountNumber(val, b, n, s) {
      if (this.title === '修改审批' && s) {
        return
      }
      if (this.title === '查看审批' && val) {
        return
      }
      this.selectType = n
      this.isCheckoutBox = b
      if (this.editProcess) {
        this.isCheckoutBox = false
      }
      this.searchVisible = val
    }
  }
}
</script>

<style lang='scss' scoped>
#addProcess {
    .addForm {
        .coluor-ball {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin-right: 7px;
        }
    }
    .dialog-footer {
        .close_btn {
            border: 1px solid #C4CBD7;
            color: #C4CBD7;
        }
    }
    .process-body {
        padding: 0 10px;
        .see-Process {
            display: flex;
            .process-box {
                display: inline-block;
                margin: 0;
                margin-bottom: 32px;
            }
            .svg-icon {
                font-size: 94px;
                margin-top: -6px;
            }
        }
        .process-box {
            display: inline-block;
            width: 188px;
            height: 78px;
            border-radius: 6px;
            background-color: #F66666;
            margin-right: 32px;
            margin-bottom: 32px;
            .process-title {
                height: 28px;
                line-height: 28px;
                font-size: 14px;
                color: #FFFFFF;
                padding: 0 9px;
            }
            .process-content {
                width: 177px;
                height: 45px;
                margin: 0 5px;
                border-radius: 6px;
                background-color: #fff;
                font-size: 14px;
                color: #797E8D;
                display: flex;
                align-items: center;
                padding: 0 3px;

                .process-text {
                    white-space: normal;
                    line-height: 18px;
                    display: -webkit-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;//此处为行数，可以改为任意数字
                }
            }
        }
        .process-box:nth-child(4n) {
            margin-right: 0;
        }
    }
}
</style>
<style lang='scss'>
#addProcess {
    .el-dialog {
        position: relative;
        top: 45% !important;
        height: 622px;
        border-radius: 10px;
    }
    .el-dialog__header {
        height: 40px;
        font-size: 16px;
        padding-left: 23px;
        border-radius: 10px 10px 0 0;
    }
    .el-dialog__body {
        height: 508px;
        padding: 36px 46px;
        border-bottom: 1px solid #C4CBD7;
    }
    .el-dialog__footer {
        display: flex;
        align-items: center;
        justify-content: right;
        height: 73px;
        padding: 0;
        padding-right: 35px;
    }
    .dialog-footer {
        .el-button {
            width: 80px;
            height: 36px;
        }
    }
    .addForm {
        .el-form-item__label {
            font-size: 16px !important;
            color: #676871;
        }
        .el-input__suffix {
            right: 10px;
        }
    }
    .process-content {
        .el-input__suffix {
            top: 8px;
            font-size: 24px;
        }
        .el-input__inner {
            border: 0;
        }
        .el-icon-arrow-right {
            position: relative;
            top: -3px;
        }
        .el-input__clear {
            position: relative;
            top: -6px;
        }
    }
}
</style>
